import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-media-library-skeleton',
  templateUrl: './media-library-skeleton.component.html',
  styleUrls: ['./media-library-skeleton.component.scss']
})
export class MediaLibrarySkeletonComponent {
  @Input() pageMode = false;
  readonly skeletonItems = Array.from({ length: 12 });
}
